import { faTriangleExclamation, faMultiply, faTrashAlt, faUserSlash } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { KeycloakUser } from "../../../model/CarbonExternalModels";
import { apiDisableUser, apiEnableUser } from "../../../messages/api/gcmUserManagement";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { UserPermission } from "../../../model/CarbonPermissionModels";
import { Button } from "userful-chronos-common-ui/dist";

interface IProps {
    user: KeycloakUser;
    permissions: UserPermission;
}

export default function UserDisable(props: IProps) {
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

    if (props.user.userProfile.userName === "admin" || !props.permissions.isUserCreator) return null;

    return (
        <>
            <Dropdown.Item
                onClick={() => {
                    setShowConfirmation(true);
                }}
            >
                <div className="gcm-icon-dropdown-menu-icon-container">
                    <FontAwesomeIcon icon={faUserSlash} />
                </div>
                <p>{props.user.userProfile.enabled ? "Disable" : "Enable"} User</p>
            </Dropdown.Item>

            <Modal
                centered
                show={showConfirmation}
                onHide={() => {
                    setShowConfirmation(false);
                }}
            >
                <div className="gcm-pop-up-modal-wrapper">
                    <div className="gcm-pop-up-modal-wrapper-body">
                        <div className="gcm-pop-up-modal-wrapper-head">
                            <div className="gcm-pop-up-modal-wrapper-title">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                                {props.user.userProfile.enabled && <h1>Disable User</h1>}
                                {!props.user.userProfile.enabled && <h1>Enable User</h1>}
                            </div>
                            <Button
                                variant="secondary"
                                iconOnly
                                onClick={() => {
                                    setShowConfirmation(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faMultiply} />
                            </Button>
                        </div>
                        {props.user.userProfile.enabled && (
                            <p>
                                Are you sure you want to disable the user:{" "}
                                <strong>"{props.user.userProfile.userName}"</strong>? This will prevent the user from
                                logging in.
                            </p>
                        )}
                        {!props.user.userProfile.enabled && (
                            <p>
                                Are you sure you want to enable the user:{" "}
                                <strong>"{props.user.userProfile.userName}"</strong>? This will allow the user to
                                logging in.
                            </p>
                        )}
                    </div>
                    <div className="confirmationDialogHorizontalWrapper reversed">
                        <Button
                            variant="danger"
                            onClick={(e) => {
                                setShowConfirmation(false);
                                if (props.user.userProfile.enabled)
                                    apiDisableUser(getGlobalStates().keycloak.token, props.user.id);
                                if (!props.user.userProfile.enabled)
                                    apiEnableUser(getGlobalStates().keycloak.token, props.user.id);
                            }}
                        >
                            {props.user.userProfile.enabled ? "Disable" : "Enable"}
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
